import React from 'react'
import PropTypes from 'prop-types'

import { akTargetGroups } from 'ak_business_constants'
import { akCountriesWithSubdivisions } from 'ak_countries'

const findSubdivisionName = (query) => {
  return akCountriesWithSubdivisions.find(({ code }) => query === code).name
}

const findTargetGroupName = (query) => {
  return akTargetGroups.find(({ id }) => query === id).name
}

const CountrySelect = ({ onChange, selected, countries }) => (
  <>
    <label className="small mb-0 form-label" htmlFor='countryCode'>
      Land
    </label>
    <select name="countryCode" id="countryCode" className="form-select form-select-sm mb-2 mb-xl-0" onChange={onChange} value={selected}>
      <option key="BLANK" value="">Alle Länder</option>
      {countries.map((code) => (
        <option key={code} value={code}>{findSubdivisionName(code)}</option>
      ))}
    </select>
  </>
)

const TargetGroupSelect = ({ onChange, selected, targetGroups }) => (
  <>
    <label className="small mb-0 form-label" htmlFor="targetGroup">
      Zielgruppe
    </label>
    <select name="targetGroup" id="targetGroup" className="form-select form-select-sm mb-2 mb-xl-0" onChange={onChange} value={selected}>
      <option key="BLANK" value="">Alle Zielgruppen</option>
      {targetGroups.map((id) => (
        <option key={id} value={id}>{findTargetGroupName(id)}</option>
      ))}
    </select>
  </>
)

const Filter = ({ businessArea, countries, countryCode, targetGroups, targetGroup, setCountryCode, setTargetGroup }) => {
  let renderable

  switch (businessArea) {
    case 'schueleraustausch':
      renderable = (
        <div className="col-12 col-md-6 col-xl-4 mr-auto">
          <CountrySelect countries={countries} selected={countryCode} onChange={(evt) => setCountryCode(evt.target.value)} />
        </div>
      )
      break
    case 'sprachreisen':
      renderable = (
        <>
          <div className="col-12 col-md-3 col-xl-2">
            <CountrySelect countries={countries} selected={countryCode} onChange={(evt) => setCountryCode(evt.target.value)} />
          </div>
          <div className="col-12 col-md-3 col-xl-2">
            <TargetGroupSelect targetGroups={targetGroups} selected={targetGroup} onChange={(evt) => setTargetGroup(evt.target.value)} />
          </div>
        </>
      )
      break
  }

  return renderable
}

Filter.propTypes = {
  businessArea: PropTypes.string.isRequired,
  countries: PropTypes.arrayOf(PropTypes.string),
  targetGroups: PropTypes.arrayOf(PropTypes.string),
  countryCode: PropTypes.string,
  targetGroup: PropTypes.string,
  setTargetGroup: PropTypes.func.isRequired,
  setCountryCode: PropTypes.func.isRequired,
}

export default Filter
